import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDropdown, type BaseDropdownOption } from './BaseDropdown';

export type MediaFormat = 'all' | 'image' | 'video' | 'carousel' | 'text';

interface MediaFormatOption extends BaseDropdownOption {
  id: MediaFormat;
}

interface MediaFormatDropdownProps {
  value: MediaFormat;
  onChange: (format: MediaFormat) => void;
  className?: string;
}

export const MediaFormatDropdown: React.FC<MediaFormatDropdownProps> = ({
  value,
  onChange,
  className = ''
}) => {
  const { t } = useTranslation();

  const mediaFormats: MediaFormatOption[] = [
    { 
      id: 'all', 
      label: t('mediaFormatDropdown.all', 'All Media Types'), 
      emoji: '📱', // Changed from 🌐 to something more relevant to media
      description: t('mediaFormatDropdown.allDesc', 'Show posts with any type of media or content.')
    },
    { 
      id: 'image', 
      label: t('mediaFormatDropdown.image', 'Image'), 
      emoji: '🖼️', 
      description: t('mediaFormatDropdown.imageDesc', 'Posts containing images only.')
    },
    { 
      id: 'video', 
      label: t('mediaFormatDropdown.video', 'Video'), 
      emoji: '🎬', 
      description: t('mediaFormatDropdown.videoDesc', 'Posts containing videos only.')
    },
    { 
      id: 'carousel', 
      label: t('mediaFormatDropdown.carousel', 'Carousel'), 
      emoji: '📷', 
      description: t('mediaFormatDropdown.carouselDesc', 'Posts with multiple images or mixed media.')
    },
    { 
      id: 'text', 
      label: t('mediaFormatDropdown.text', 'Text Only'), 
      emoji: '📝', 
      description: t('mediaFormatDropdown.textDesc', 'Posts with text content only, no media.')
    }
  ];

  return (
    <BaseDropdown
      value={value}
      onChange={(newValue) => onChange(newValue as MediaFormat)}
      options={mediaFormats}
      className={className}
    />
  );
}; 